import React from "react";

const Heading = () => {
  return <div className="absolute -z-30"></div>;
};

export default Heading;
